// extracted by extract-css-chunks-webpack-plugin
module.exports = {"rc-results-panel-header":"j_Toyw","rc-results-panel-header-title":"_3AUw75","rc-results-panel-header-message":"aWH-Fi"};